import React from 'react';
import AldagdalBurtgeh from './aldagdalBurtgeh';

const PageList = () => <AldagdalBurtgeh />;

export default PageList;
